import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

const UsernamePromptModal = ({ isOpen, onClose, onSave, onDismiss }) => {
  const [ptcglUsername, setPtcglUsername] = useState('');
  const [limitlessUsername, setLimitlessUsername] = useState('');

  if (!isOpen) return null;

  const handleSave = () => {
    onSave({ ptcglUsername, limitlessUsername });
    onClose();
  };

  const handleDismiss = () => {
    onDismiss();
    onClose();
  };

  const modalContent = (
    <div className="modal-overlay" onClick={handleDismiss}>
      <div className="modal-content username-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Connect Your Accounts</h2>
          <button className="modal-close-btn" onClick={handleDismiss}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            Link your PTCGL and Limitless usernames to enhance your experience and track your tournament performance.
          </p>

          <div className="form-group">
            <label className="form-label" htmlFor="ptcgl-username">
              <i className="fas fa-gamepad"></i> PTCGL Username
            </label>
            <input
              type="text"
              id="ptcgl-username"
              className="form-control"
              value={ptcglUsername}
              onChange={(e) => setPtcglUsername(e.target.value)}
              placeholder="Enter your PTCGL username"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="limitless-username">
              <i className="fas fa-trophy"></i> Limitless Username
            </label>
            <input
              type="text"
              id="limitless-username"
              className="form-control"
              value={limitlessUsername}
              onChange={(e) => setLimitlessUsername(e.target.value)}
              placeholder="Enter your Limitless username"
            />
          </div>

          <p className="modal-note">
            <i className="fas fa-info-circle"></i> You can always update these later in your account settings.
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={handleDismiss}>
            No thanks
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={!ptcglUsername && !limitlessUsername}
          >
            <i className="fas fa-save"></i> Save Usernames
          </button>
        </div>
      </div>
    </div>
  );

  // Render the modal at the document body level to avoid container constraints
  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default UsernamePromptModal;
